module.exports = __webpack_public_path__ + "static/bg-testimonial.da6d1847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-testimonial.jpg
// module id = 147
// module chunks = 35783957827783 162898551421021 172322841747965